
    angular.module('qkr').controller('profileDataUploadController', ProfileDataUploadController);

    ProfileDataUploadController.$inject = ['$uibModal', 'messageService', 'lookupDataUploadService',
                                        'gettextCatalog', 'appConfig', 'beneficiariesService'];

    function ProfileDataUploadController($uibModal, messageService, lookupDataUploadService,
                                         gettextCatalog, appConfig, beneficiariesService) {

        const vm = this;

        vm.loading = true;
        vm.profileDataUploadForm = {};
        vm.file = {};
        vm.f = null;
        vm.orderProp = 'lastName';
        vm.orderReverse = false;
        vm.query = '';
        vm.lookupBeneficiaryList = [];
        vm.nonMatchedLookupBeneficiaryList = [];
        vm.matchedLookupBeneficiaryList = [];
        vm.totalUploadedBeneficiary = '';
        vm.latestUploadDate = '';
        vm.reload = false;
        vm.reason = {};
        vm.yearWarningMessage = '';
        vm.referenceWarningMessage = '';
        vm.fileName = 'beneficiary_profile_dataupload.xls';
        vm.errorDetails = '';

        vm.init = () => {
            // Read the Lookup Beneficiaries
            vm.loadLookupBeneficiaries();

            // Check that 'Year' beneficiary custom field definition is defined
            vm.loadBeneficiaryCustomFields();
        };

        const errorHandler = (text, data) => {
            let errorMsg = gettextCatalog.getString(text);
            if (data && data.exception) {
                errorMsg =  errorMsg + '(' + data.exception + ')';
            }
            vm.reason = {
                message: errorMsg
            };
            messageService.error(vm.reason);
            vm.uploading = false;
        };

        const errorHandlerFileUpload = (text, response) => {
            let errorMsg = gettextCatalog.getString(text);
            if (response && response.data.exception) {
                vm.errorDetails =  response.data.exception;
            }
            vm.reason = {
                message: errorMsg
            };
            messageService.error(vm.reason);
            vm.uploading = false;
        };

        vm.loadBeneficiaryCustomFields = () => {
            const successResponse = (response) => {
                response.forEach(val => {
                    vm.yearWarningMessage = val.fieldName === 'Year' ?
                                                '\'' + gettextCatalog.getString('Year') + '\'' +
                                                gettextCatalog.getString('is not configured Student Details') : '';

                    vm.referenceWarningMessage = val.fieldName === 'ReferenceNumber' ?
                                                    '\'' + gettextCatalog.getString('ReferenceNumber') + '\'' +
                                            gettextCatalog.getString('is not configured Student Details') : '';
                });
            };
            beneficiariesService.loadBeneficiaryCustomFields()
                    .then(successResponse, errorHandler.bind(null, 'load BeneficiaryCustomFields failed'));
        };

        vm.loadLookupBeneficiaries = () => {
            const successResponse = (response) => {
                const listLookupBeneficiariesResponse = response.data;

                vm.sortLookupBeneficiaries(listLookupBeneficiariesResponse);

                messageService.hide();
            };
            lookupDataUploadService.loadLookupBeneficiaryInfo()
                    .then(successResponse, errorHandler.bind(null, ' load lookup beneficiary failed '));
        };

        vm.unknownLookupBeneficiaryConfig = () => {
            const successResponse = (response) => {
                const modalInstance = $uibModal.open({
                        template: require('../templates/accountancy/unknownBeneficiaryEmailConfig.html'),
                        controller: 'unknownBeneficiaryEmailConfigController as vm',
                        windowClass: 'fade modal-huge',
                        backdrop: 'static',
                        resolve: {
                            data() {
                                return response.data;
                            }
                    }
                });
            };
            lookupDataUploadService.getUnknownLookupBeneficiaryConfig()
                    .then(successResponse, errorHandler.bind(null, ' unknownBeneficiaryEmailConfig failed '));
        };

        vm.uploadLookupBeneficiaries = (file) => {
            if (!file) {
                return;
            }
            vm.f = file;
            lookupDataUploadService.uploadLookupBeneficiaries(vm.f)
                .then(successUploadResponse, errorHandlerFileUpload.bind(null, 'File upload failed '));
        };

        vm.sortBy = (colName) => {
            if (vm.orderProp === colName) {
                vm.orderReverse = !vm.orderReverse;
            } else {
                vm.orderProp = colName;
                vm.orderReverse = false;
            }
        };

        vm.sortIcon = (colName) => {
            if (colName === vm.orderProp) {
                if (vm.orderReverse) {
                    return 'glyphicon glyphicon-chevron-up';
                } else {
                    return 'glyphicon glyphicon-chevron-down';
                }
            } else {
                return null;
            }
        };

        const successUploadResponse = (listFamiliesResponse) => {
            if (listFamiliesResponse.lastUploadedDate === vm.latestUploadDate) {
                vm.uploadMessage = 'There were no records updated or created in the last file uploaded';
            }
            vm.totalUploadedBeneficiary = listFamiliesResponse.numLastUploadedBeneficiary;
            vm.latestUploadDate = listFamiliesResponse.lastUploadedDate;
            vm.uploading = false;
            vm.errorDetails = '';
            vm.sortLookupBeneficiaries(listFamiliesResponse.data);
            messageService.success(gettextCatalog.getString('File uploaded successfully.'));
        };

        vm.sortLookupBeneficiaries = (listLookupBeneficiariesInfo) => {
            vm.lookupBeneficiaryList = listLookupBeneficiariesInfo.lookupBeneficiaries;
            vm.nonMatchedLookupBeneficiaryList = listLookupBeneficiariesInfo.nonMatchedLookupBeneficiaries;
            vm.matchedLookupBeneficiaryList = listLookupBeneficiariesInfo.matchedLookupBeneficiaries;
            vm.totalUploadedBeneficiary = listLookupBeneficiariesInfo.numLastUploadedBeneficiary;
            vm.latestUploadDate = listLookupBeneficiariesInfo.lastUploadedDate;
        };

        vm.updateLookupBeneficiary = (lookupBeneficiary) => {
            const successHandler = (lookupBeneficiary) => {
                vm.loadLookupBeneficiaries();
                messageService.success(gettextCatalog.getString('lookup Beneficiary updated'));
            };
            lookupDataUploadService.updateLookupBeneficiary(lookupBeneficiary)
                                   .then(successHandler, errorHandler.bind(null, 'update failed '));
        };

        vm.hideLookupBeneficiary = (lookupBeneficiary) => {
            const successHideHandler = (data) => {
                vm.loadLookupBeneficiaries();
                messageService.success(gettextCatalog.getString('hide lookup Beneficiary'));
            };
            lookupDataUploadService.hideLookupBeneficiary(lookupBeneficiary)
                                    .then(successHideHandler, errorHandler.bind(null, 'hide lookup Beneficiary failed '));
        };

        vm.unHideLookupBeneficiary = (lookupBeneficiary) => {
            const successUnhideHandler = (data) => {
                vm.loadLookupBeneficiaries();
                messageService.success(gettextCatalog.getString('unhide lookup Beneficiary'));
            };
            lookupDataUploadService.unHideLookupBeneficiary(lookupBeneficiary)
                                    .then(successUnhideHandler, errorHandler.bind(null, 'Unhide lookup Beneficiary failed '));
        };

        vm.showErrorDetails = (errorDetails) => {
            const modalInstance = $uibModal.open({
                template: require('../templates/accountancy/uploadErrorDetails.html'),
                controller: 'errorUploadLookupBeneficiaryController as vm',
                windowClass: 'fade modal-huge',
                backdrop: 'static',
                resolve: {
                    data() {
                        return errorDetails;
                    }
                }
            });
        };

        vm.init();
    }



// WEBPACK FOOTER //
// ./src/controllers/profile.data.upload.controller.js